import { component } from 'picoapp'
import fetch from 'unfetch'

export default component((node, ctx) => {
    const zipCode = node.querySelector('#zipcode')
    const city = node.querySelector('#city')
    const province = node.querySelector('#state')
    const form = node.querySelector('.water-report-form')
    const formCityState = node.querySelector('.water-report-city-state-form')
    const results = node.querySelector('.water-report-results')
    const unkonwnResults = node.querySelector('.water-report-unkown')

    function clearMessage() {
        let message = node.querySelector('.water-report-form__message')
        message.innerHTML = '';
        message.style.display = 'none';
    }
    function showMessage(type, msg) {
        let message = node.querySelector('.water-report-form__message')
        let errorMsg = document.createElement('div');
        errorMsg.className = 'message message--' + type;
        errorMsg.innerHTML = msg;
        message.appendChild(errorMsg);
        message.style.display = 'block';
        scrollToElement(message);
    }

    function checkStatus(response) {
        clearMessage();
        if (response.ok) {
          return response;
        } else if (response.status == 404) {
            showMessage('error', 'Your zip code was not found. Please ensure you have entered it properly.')
            var error = new Error(response.statusText);
            error.response = response;
            return Promise.reject(error);
        } else {
            showMessage('error', 'A water quality report could not be retrieved. Please ensure you have entered your zip code properly.')
          var error = new Error(response.statusText);
          error.response = response;
          return Promise.reject(error);
        }
    }

    function fillData(selector, value, className) {
        let elements = node.querySelectorAll(selector);
        for (let i = 0; i < elements.length; i++) {
            elements[i].innerHTML = value;
            if (className != null) {
                elements[i].className = selector.replace('.', '') + ' ' + className;
            }
        }
    }

    function populateSates(selected, selectedCity) {
        if (!province.hasChildNodes()) {
            province.innerHTML = '';
            fetch('https://malibucapi.taylorpond.com/api/states')
            .then( checkStatus )
            .then( r => r.json() )
            .then( data => {
                    for (let i = 0; i < data.length; i++) {
                        let thisState = data[i];
                        let option = document.createElement('option');
                        option.value = thisState.state;
                        option.innerHTML = thisState.state_full_name;
                        province.appendChild(option);
                    }
                    province.value = selected;
                }
            );  
        } else {
            province.value = selected;
        }
        populateCities(selected, selectedCity);
    }

    function populateCities(selectedState, selectedCity) {
        city.innerHTML = '';
        fetch('https://malibucapi.taylorpond.com/api/cities/' + selectedState)
            .then( checkStatus )
            .then( r => r.json() )
            .then( data => {
                let defaultOption = document.createElement('option');
                defaultOption.value = "";
                defaultOption.innerHTML = "-Select-";
                city.appendChild(defaultOption);
                    for (let i = 0; i < data.length; i++) {
                        let thisCity = data[i];
                        let option = document.createElement('option');
                        
                        option.value = thisCity.city;
                        option.innerHTML = thisCity.city;
                        city.appendChild(option);
                    }

                    if (selectedCity != null) {
                        city.value = selectedCity;
                    }
                }
            );  

    }

    function displayResults(data, type) {
        let concernList = '';
        let concernResults = node.querySelectorAll('.concern');
        let hardness = data.water_hardness.replace(/\s+/g, '-').toLowerCase();
        for (let i = 0; i < concernResults.length; i++) {
                concernResults[i].style.display = "none";
            }

            let concernOptions = node.querySelectorAll('input[name="concern"]');
            for (let i = 0; i < concernOptions.length; i++) {
                let option = concernOptions[i];
                if (option.checked) {
                    if (concernList.length > 0) {
                        concernList += ',';
                    }
                    concernList += option.value;
                    //console.log('.concern--' + option.value + '-' + hardness);
                    let concernResult = node.querySelector('.concern--' + option.value + '-' + hardness);
                    if (concernResult != null) {
                        concernResult.style.display = "block";
                    }
                }
            }   

        if (data.water_hardness == "Unknown") {
            results.style.display = "none";
            unkonwnResults.style.display = "block";
            populateSates(data.location.state);
            scrollToElement(unkonwnResults);
        } else {
            results.style.display = "block";
            unkonwnResults.style.display = "none";
            //console.log(hardness);
            let waterSources = node.querySelector('.water-sources-list');
            waterSources.innerHTML = '';
            let treatmentFacliities = node.querySelector('.treatment-facilities tbody');
            treatmentFacliities.innerHTML = '';

                     

            fillData('.city', data.location.city);
            fillData('.county', data.location.county);
            fillData('.hardness', data.water_hardness, hardness);

            if (data.private_well_population != null) {
                fillData('.wells', data.private_well_population.toLocaleString());
                node.querySelector('.wells-intro').style.display = "block";                
            } else {
                //console.log('no well data');
                node.querySelector('.wells-intro').style.display = "none";                
            }
            let maxChlorine = 0;
            let maxPh = 0;
            for (let i = 0; i < data.water_plants.length; i++) {
                if (data.water_plants[i].chlorine > maxChlorine) {
                    maxChlorine = data.water_plants[i].chlorine;
                }
                if (data.water_plants[i].ph > maxPh) {
                    maxPh = data.water_plants[i].ph;
                }
                let li = document.createElement('li');
                if (data.water_plants[i].water_source != null && data.water_plants[i].water_source.length > 0) {
                    li.innerHTML = data.water_plants[i].water_source;
                }
                if (data.water_plants[i].source_type != null && data.water_plants[i].source_type.length > 0) {
                    li.innerHTML += ' (' + data.water_plants[i].source_type + ')';
                }
                if (li.innerHTML.length > 0) {
                    waterSources.appendChild(li);
                }

                let tr = document.createElement('tr');

                let td1 = document.createElement('td');
                td1.innerHTML = '<strong>Treatment Plant Name</strong> ' + data.water_plants[i].plant_name;
                tr.appendChild(td1);

                let td2 = document.createElement('td');
                if (data.water_plants[i].hardness != null) {
                    td2.innerHTML = '<strong>Hardness</strong> ' + data.water_plants[i].hardness;
                } else {
                    td2.innerHTML = '<strong>Hardness</strong> ' + 'N/A';
                }
                tr.appendChild(td2);

                let td3 = document.createElement('td');
                if (data.water_plants[i].chlorine != null) {
                    td3.innerHTML = '<strong>Chlorine</strong> ' + data.water_plants[i].chlorine;
                } else {
                    td3.innerHTML = '<strong>Chlorine</strong> ' + 'N/A';
                }
                tr.appendChild(td3);

                let td4 = document.createElement('td');
                if (data.water_plants[i].ph != null) {
                    td4.innerHTML = '<strong>pH</strong> ' + data.water_plants[i].ph;
                } else {
                    td4.innerHTML = '<strong>pH</strong> ' + 'N/A';
                }
                tr.appendChild(td4);

                treatmentFacliities.appendChild(tr);
            }
            fillData('.chlorine', maxChlorine);
            fillData('.ph', maxPh);

            scrollToElement(results);

        }

        let url = window.location.href.split('?')[0];
        if (type == 'zipcode') {
            url += '?zipcode=' + zipCode.value;
        } else {
            url += '?city=' + city.value + '&state=' + province.value;
        }
        if (concernList.length > 0) {
            url += '&conditions=' + concernList;
        }
        history.pushState(null, null, url);

    }

    function searchByZipCode(zipcode) {
        if (zipcode.length >= 5) {
            fetch('https://malibucapi.taylorpond.com/api/reports/' + zipcode)
            .then( checkStatus )
            .then( r => r.json() )
            .then( data => {
                displayResults(data, 'zipcode');
                }
            );        
        } else {
            clearMessage();
            showMessage('error', 'Please enter a valid zip code.');
        }
    }

    function searchByCityState(city, province) {
        if (city.length >= 1) {
            fetch('https://malibucapi.taylorpond.com/api/reports/' + city + '/' + province)
            .then( checkStatus )
            .then( r => r.json() )
            .then( data => {
                displayResults(data, 'cityState');
                }
            );        
        } else {
            clearMessage();
            showMessage('error', 'Please select a city.');
        }
    }

    function scrollToElement(element) {
        const yOffset = -4 * parseFloat(getComputedStyle(document.documentElement).fontSize); 
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({top: y, behavior: 'smooth'});
    }

    form.addEventListener("submit", e => {
        e.preventDefault();
        searchByZipCode(zipCode.value)
    });

    formCityState.addEventListener("submit", e => {
        e.preventDefault();
        searchByCityState(city.value, province.value)
    });

    province.addEventListener('change', e => {
        populateCities(province.value);
    });

    let urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has('conditions')) {
        let conditions = urlParams.get('conditions').split(',');
        for (let i = 0; i < conditions.length; i++) {
            let option = node.querySelector('input[value="' + conditions[i] + '"]');
            if (option != null) {
                option.checked = true;
            }
        }
    }

    if (urlParams.has('zipcode')) {
        zipCode.value = urlParams.get('zipcode');
        searchByZipCode(zipCode.value);
    }

    if (urlParams.has('state') && urlParams.has('city')) {
        let province = urlParams.get('state');
        let city = urlParams.get('city');
        populateSates(province, city);
        searchByCityState(city, province);
    }

})
